export function isPayHost(): boolean {
  const payHost = process.env.REACT_APP_PAY_HOST;
  if (!payHost) return false;

  return (
    window.location.hostname ===
    payHost.replace(/^https?:\/\//, "").split("/")[0]
  );
}
